/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component} from '@angular/core';

@Component({
  standalone: false,
  selector: 'adn-tier-route-page',
  template: '<adn-tier-list-page></adn-tier-list-page>'
})
export class TierRoutePageComponent {
}
